import { cva } from "class-variance-authority";

// SCSS-based accordion variants using WeLoop design system classes
export const accordionVariants = cva(
  "wl-accordion wl-accordion-shadcn", // Base WeLoop accordion class
  {
    variants: {
      size: {
        default: "", // Default size is handled by wl-accordion
        sm: "wl-accordion-sm",
        md: "wl-accordion-md",
        lg: "wl-accordion-lg",
      },
      variant: {
        default: "", // Default variant
        chevron: "wl-accordion-chevron-variant",
        "plus-minus": "wl-accordion-plus-minus-variant",
      },
    },
    defaultVariants: {
      size: "default",
      variant: "default",
    },
  }
);

// Item variants for AccordionItem component
export const accordionItemVariants = cva(
  "wl-accordion-item", // Base WeLoop accordion item class
  {
    variants: {
      variant: {
        default: "", // Default variant
        bordered: "wl-accordion-item-bordered",
        card: "wl-accordion-item-card",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

// Trigger variants for AccordionTrigger component
export const accordionTriggerVariants = cva(
  "wl-accordion-trigger", // Base WeLoop accordion trigger class
  {
    variants: {
      size: {
        default: "", // Default size is handled by wl-accordion-content
        sm: "wl-accordion-toggle-sm",
        md: "wl-accordion-toggle-md",
        lg: "wl-accordion-toggle-lg",
      },
      variant: {
        default: "", // Default variant
        button: "wl-accordion-toggle-button",
        link: "wl-accordion-toggle-link",
      },
    },
    defaultVariants: {
      size: "default",
      variant: "default",
    },
  }
);
